import { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import Offline from '../views/Offline.vue'
import { Store } from 'vuex'

export function createSiteRoutes (store: Store<any>): RouteConfig[] {
  return [
    { // for PWA, they open automatically /
      path: '/index.html',
       redirect: { name: 'home' }
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter (to, from, next) {
        next()
      }
    },
    {
      path: '/feedback',
      name: 'feedback',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
      beforeEnter (to, from, next) {
        next()
      }
    },
    {
      path: '/offline',
      name: 'offline',
      component: Offline
    }

  ]
}
